import { AdminEngagementBlueprintActivitiesParams } from "PFCore/services/admin/engagement_blueprints";
import { Id } from "PFTypes";

export const engagementBlueprintsKeys = {
  all: () => ["admin", "engagementBlueprints"],
  list: (params = {}) => [...engagementBlueprintsKeys.all(), "list", params],
  single: (id: Id) => [...engagementBlueprintsKeys.all(), String(id)],
  activities: (id: Id, params: AdminEngagementBlueprintActivitiesParams) => [
    ...engagementBlueprintsKeys.single(id),
    "activities",
    params
  ]
};
